import { wait } from '@mbrtargeting/metatag-utils';
import { markSdg } from '../../../utils/performance.js';
import { StateMachine } from '../../state-machine.js';
import { LifecycleAction } from './adslot-lifecycle-state.js';
import { Adslot } from './adslot.js';

export enum AdserverLoadState {
    ERROR = 'ERROR',
    IDLE = 'IDLE',
    REQUESTED = 'REQUESTED',
    RESPONDED = 'RESPONDED',
    /**
     * AdServer can fill the slot.
     */
    FILLED = 'FILLED',
    /**
     * Ad server does not directly render the ad.
     * May still pass information to slot (like keyvalues, targetings).
     */
    EMPTY = 'EMPTY',
}

export enum AdserverLoadAction {
    REQUEST = 'REQUEST',
    RESPOND = 'RESPOND',
    FILL = 'FILL',
    NOAD = 'NOAD',
}

export class AdslotAdserverLoadState extends StateMachine<AdserverLoadState, AdserverLoadAction> {

    constructor(private adslot: Adslot, private adServerName: string) {
        super({
            logPrefix: `${adServerName}: LoadState ${adslot.slotName.toUpperCase()}`,
            initialState: AdserverLoadState.IDLE,
            transitions: [
                { from: AdserverLoadState.IDLE, action: AdserverLoadAction.REQUEST, to: AdserverLoadState.REQUESTED },
                { from: AdserverLoadState.REQUESTED, action: AdserverLoadAction.RESPOND, to: AdserverLoadState.RESPONDED },
                { from: AdserverLoadState.RESPONDED, action: AdserverLoadAction.FILL, to: AdserverLoadState.FILLED },
                { from: AdserverLoadState.RESPONDED, action: AdserverLoadAction.NOAD, to: AdserverLoadState.EMPTY },
                { from: AdserverLoadState.FILLED, action: AdserverLoadAction.REQUEST, to: AdserverLoadState.REQUESTED },
                { from: AdserverLoadState.EMPTY, action: AdserverLoadAction.REQUEST, to: AdserverLoadState.REQUESTED },
            ],
            initialContext: {},
        });

        this.onAction(AdserverLoadAction.REQUEST, async () => {
            markSdg(`ad-request-sent-to-google_mt_${this.adslot.slotName}`);
        });
        this.onAction(AdserverLoadAction.RESPOND, async () => {
            markSdg(`ad-request-received-from-google_mt_${this.adslot.slotName}`);
        });
        this.onAction(AdserverLoadAction.FILL, async () => {
            await this.adslot.lifecycle.dispatch(LifecycleAction.FILL);

            //Google is fully responsible for rendering the ad, we just give some time for our "renderingState" to progress
            adslot.renderCreative(wait(10)) //don't await, otherwise stateTransition will break
        });
    }
}
